import { EMPLOYER_PAYROLL_REPORTS_DOWNLOAD } from './payroll-report.types';

export const downloadPayrollReport = payload => ({
  type: EMPLOYER_PAYROLL_REPORTS_DOWNLOAD,
  payload,
});
